module.exports = __webpack_public_path__ + "img/buzzztv_logo.a76be2b8.svg";